const GRID_SIZE = 4;
export const size = integer => `${integer * GRID_SIZE}px`;

export default {
  popupWidth: size(68),
  popupMaxHeight: '30vh',
  popupMaxHeightMobile: size(58),
};
